import { render } from "./VueYoutube.vue?vue&type=template&id=3d5f02f8"
import script from "./VueYoutube.vue?vue&type=script&lang=js"
export * from "./VueYoutube.vue?vue&type=script&lang=js"

import "./VueYoutube.vue?vue&type=style&index=0&id=3d5f02f8&lang=css"

import exportComponent from "/Users/gary/vhosts/confzilla_root/confzilla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__